inputs-complex-check-special-reports
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      input(type="hidden" value="{opts.value}" name="{opts.name}")
      .row
        .col-md-6.customer-wrap
          label.col-form-label(style="font-size: 1rem")
            | {opts.label1}
          div(each="{item, index in customer.items}")
            label.d-flex
              input(if="{item.checked}" type="checkbox" checked="checked" onchange="{onChangeCheckbox(customer)}")
              input(if="{!item.checked}" type="checkbox" onchange="{onChangeCheckbox(customer)}")
              span.num {item.label}
              input.filename.form-control(type="text" value="{item.value}" onBlur="{onChangeText(customer)}")
        .col-md-6.other-wrap
          label.col-form-label(style="font-size: 1rem")
            | {opts.label2}
          div(each="{item, index in other.items}")
            label.d-flex
              input(if="{item.checked}" type="checkbox" checked="checked" onchange="{onChangeCheckbox(other)}")
              input(if="{!item.checked}" type="checkbox" onchange="{onChangeCheckbox(other)}")
              span.num {item.label}
              input.filename.form-control(type="text" value="{item.value}" onBlur="{onChangeText(other)}")
      div
        label.col-form-label(style="font-size: 1rem")
          | {opts.label3}
        inputs-without-label-textarea(tag-scope="{this.tagScope}.memo_for_reports")
  script(type="typescript").
    this.mixin('inputs.complex.check-special-reports');
    console.log(this.opts)
  style(scoped).
    .num {
      margin: .4rem .5rem 0 .5rem;
    }
    .filename {
    }
